import { createContext } from "react";

const distributorsContext = createContext();

export default distributorsContext;